// role-sidemenu-map.service.js

import axiosInstance from "../axiosInstance";

export const roleSidemenuMapService = {
  create: async (obj) => {
    try {
      let response = await axiosInstance.post("/sidemenu-role-map", obj);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  fetch: async (limit, skip) => {
    try {
      let response = await axiosInstance.get(
        `/sidemenu-role-map?&$limit=${limit || 15}&$skip=${
          skip || 0
        }&$populate=sidemenu&$populate=role`,
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  fetchByRole: async (roleId) => {
    try {
      const response = await axiosInstance.get(
        `/sidemenu-role-map?role=${roleId}&$populate=sidemenu&$populate=role&$limit=1000`,
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  fetchByRolePaginated: async (roleId, query = "") => {
    try {
      const base = `/sidemenu-role-map?role=${roleId}&${query}`;
      const response = await axiosInstance.get(base);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  edit: async (id, obj) => {
    try {
      let response = await axiosInstance.patch(`/sidemenu-role-map/${id}`, obj);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  delete: async (id) => {
    try {
      let response = await axiosInstance.delete(`/sidemenu-role-map/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  fetchByLoggedInUser: async () => {
    try {
      const response = await axiosInstance.get(`/sidemenu-list`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
